<template>
  <el-dialog
    :visible.sync="visible"
    width="90%"
    top="3vh"
    append-to-body
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="stock-take-dialog stock-take-detail-dialog"
  >
    <span slot="title">盘点单详情 - {{ sheet.sheetNo || '' }}</span>
    <div class="dialog-body" v-loading="loading">
      <div ref="pdfExportRoot" class="pdf-export-root">
      <el-card class="nx-section-card" shadow="never">
        <div class="nx-card-header">
          <div class="nx-card-title">盘点单信息</div>
          <div class="nx-card-extra">
            <el-tag v-if="sheet.sheetStatus === 0" size="mini">草稿</el-tag>
            <el-tag v-else-if="sheet.sheetStatus === 1" size="mini" type="success">已提交</el-tag>
            <el-tag v-else-if="sheet.sheetStatus === 2" size="mini" type="warning">已回写库存</el-tag>
            <span v-else class="detail-info-status-empty">-</span>
          </div>
        </div>
        <el-form label-width="96px" size="small" class="detail-base-form">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="盘点单编号">
                <span class="detail-text">{{ sheet.sheetNo || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点时间">
                <span class="detail-text">{{ sheet.countTime || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点人">
                <span class="detail-text">{{ sheet.counterName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点煤棚">
                <span class="detail-text">{{ sheet.stockName || sheet.stockCode || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <el-card class="nx-section-card" shadow="never">
        <div class="summary-grid">
          <div class="summary-item">
            <div class="summary-label">当前总库存(吨)</div>
            <div class="summary-value">{{ formatNumber(sheet.totalBookWeight) }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">实盘数量(吨)</div>
            <div class="summary-value">{{ formatNumber(sheet.totalActualWeight) }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">差异(吨)</div>
            <div class="summary-value summary-value--diff">
              {{ formatDiff(sheet.totalDiffWeight) }}
            </div>
          </div>
          <div class="summary-item">
            <div class="summary-label">差异率(%)</div>
            <div class="summary-value summary-value--diff">
              {{ formatDiff(sheet.totalDiffRate, true) }}
            </div>
          </div>
        </div>
      </el-card>

      <el-card class="nx-section-card" shadow="never">
        <div class="nx-card-header">
          <div class="nx-card-title">盘点明细</div>
        </div>
        <el-table
          class="stock-take-lines-table"
          :data="lines"
          height="480px"
          size="mini"
        >
          <el-table-column prop="locationCode" label="堆位编码" width="120" />
          <el-table-column prop="locationName" label="堆位名称" width="140" show-overflow-tooltip />
          <el-table-column prop="custName" label="货主" width="140" show-overflow-tooltip />
          <el-table-column prop="cargoName" label="煤种" width="120" show-overflow-tooltip />
          <el-table-column prop="bookWeight" label="账面(吨)" width="110">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.bookWeight) }}
            </template>
          </el-table-column>
          <el-table-column prop="capacityLimit" label="容量上限(吨)" width="120">
            <template slot-scope="scope">
              {{ scope.row.capacityLimit != null ? formatNumber(scope.row.capacityLimit) : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="actualWeight" label="实盘(吨)" width="150">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.actualWeight) }}
            </template>
          </el-table-column>
          <el-table-column prop="diffWeight" label="差异(吨)" width="110">
            <template slot-scope="scope">
              <span
                :class="scope.row.diffWeight > 0 ? 'diff-positive' : (scope.row.diffWeight < 0 ? 'diff-negative' : '')"
              >
                {{ formatDiff(scope.row.diffWeight) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="diffRate" label="差异率(%)" width="110">
            <template slot-scope="scope">
              <span
                :class="scope.row.diffRate > 0 ? 'diff-positive' : (scope.row.diffRate < 0 ? 'diff-negative' : '')"
              >
                {{ formatDiff(scope.row.diffRate, true) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="diffReason" label="差异原因" min-width="180" show-overflow-tooltip />
        </el-table>
      </el-card>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" plain :loading="exporting" :disabled="loading || !sheet.sheetNo" @click="exportPdf">
        导出PDF
      </el-button>
      <el-button size="small" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getSheetDetail } from '../api'

const HTML2PDF_SRC =
  'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js'

export default {
  name: 'StockTakeDetailDialog',
  data() {
    return {
      visible: false,
      loading: false,
      exporting: false,
      sheet: {},
      lines: []
    }
  },
  methods: {
    async open(sheetId) {
      if (!sheetId) return
      this.visible = true
      this.loading = true
      try {
        const { data } = await getSheetDetail(sheetId)
        const res = (data && data.data) || {}
        this.sheet = res.sheet || {}
        this.lines = res.lines || []
      } finally {
        this.loading = false
      }
    },
    formatNumber(val) {
      if (val === null || val === undefined || Number.isNaN(Number(val))) return '0'
      return Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDiff(val, isPercent = false) {
      if (val === null || val === undefined || Number.isNaN(Number(val))) return isPercent ? '0.00%' : '0.00'
      const num = Number(val)
      const fixed = num.toFixed(2)
      if (isPercent) {
        return `${fixed}%`
      }
      return fixed
    },
    loadHtml2Pdf() {
      return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && window.html2pdf) {
          resolve(window.html2pdf)
          return
        }
        const existing = document.querySelector('script[data-html2pdf]')
        if (existing) {
          existing.addEventListener('load', () => resolve(window.html2pdf))
          existing.addEventListener('error', reject)
          return
        }
        const s = document.createElement('script')
        s.src = HTML2PDF_SRC
        s.async = true
        s.setAttribute('data-html2pdf', '1')
        s.onload = () => resolve(window.html2pdf)
        s.onerror = () => reject(new Error('html2pdf 加载失败'))
        document.head.appendChild(s)
      })
    },
    async exportPdf() {
      const el = this.$refs.pdfExportRoot
      if (!el || !this.sheet.sheetNo) {
        this.$message.warning('暂无可导出内容')
        return
      }
      this.exporting = true
      try {
        const h2p = await this.loadHtml2Pdf()
        const wrap = document.createElement('div')
        wrap.style.padding = '4px 8px 0'
        const titleEl = document.createElement('h1')
        titleEl.textContent = '盘点单详情 - ' + this.sheet.sheetNo
        titleEl.style.cssText =
          'text-align:center;font-size:18px;font-weight:600;margin:0 0 14px;color:#303133;font-family:PingFang SC,Microsoft YaHei,sans-serif'
        wrap.appendChild(titleEl)
        wrap.appendChild(el.cloneNode(true))
        const safeNo = String(this.sheet.sheetNo).replace(/[/\\:*?"<>|]/g, '_')
        const opt = {
          margin: [0.5, 0.5, 0.5, 0.5],
          filename: '盘点单_' + safeNo + '.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, letterRendering: true, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        }
        await h2p().set(opt).from(wrap).save()
      } catch (e) {
        this.$message.error('导出失败，请稍后重试或使用浏览器打印另存为 PDF')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/nx-tokens.scss';

.detail-info-status-empty {
  font-size: 13px;
  color: $nx-color-text-3;
}

.stock-take-dialog .el-dialog__body {
  padding-top: 8px;
}

.dialog-body {
  max-height: 78vh;
  overflow: auto;
}

.pdf-export-root {
  min-height: 40px;
}

.detail-base-form {
  padding: 0;
}

.detail-text {
  color: $nx-color-text-1;
  word-break: break-all;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: $nx-space-4;
}

.summary-item {
  flex: 1 1 160px;

  .summary-label {
    font-size: 12px;
    color: $nx-color-text-2;
    margin-bottom: $nx-space-1;
  }

  .summary-value {
    font-size: 18px;
    font-weight: 600;
    color: $nx-color-text-1;

    &.summary-value--diff {
      color: #ef4444;
    }
  }
}

.diff-positive {
  color: #10b981;
}

.diff-negative {
  color: #ef4444;
}

.stock-take-dialog ::v-deep .stock-take-lines-table.el-table {
  .el-table__body .el-table__cell {
    height: auto;
    min-height: 48px;
    vertical-align: middle;
  }

  .el-table__body .el-table__cell .cell {
    overflow: visible;
    line-height: normal;
  }
}
</style>
